import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';

import { ProgressSpinner } from 'primeng/progressspinner';

import { LoaderState } from '@cxc/core/services';

@Component({
  selector: 'loader-wrapper, [loader-wrapper], [loaderWrapper]',
  templateUrl: './loader-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ProgressSpinner],
})
export class LoaderWrapperComponent {
  loaderKey = input('true');
  background = input(true);
  showBackgroundComponent = input(false);
  ignoreChecksAndShow = input(false);

  loaderState = inject(LoaderState);

  showLoader = computed(() => {
    if (this.ignoreChecksAndShow()) {
      return true;
    }

    return (
      this.loaderState.loadingMap().has(this.loaderKey()) &&
      this.loaderState.loadingMap().get(this.loaderKey())
    );
  });
}
